import Vue from 'vue'
import VueRouter from 'vue-router'
import StagePresenter from '../components/Stages/StagePresenter.vue'
import StageEnvironment from '../components/Stages/Types/StageEnvironment.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/:packageid',
    name: 'ViewerXP',
    display: 'ViewerXP',
    component: StagePresenter,
    props : true
  },
  {
    path: '/:packageid/env/:stageid',
    name: 'Environment',
    display: 'Environment',
    component: StageEnvironment,
    props : true
  }
  
  /*
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( '../views/About.vue')
  }
  */
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
